import * as React from "react";
import { forwardRef } from "react";
const SvgVector = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 41, height: 41, viewBox: "0 0 41 41", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M8.97382 0.846191V9.00998H26.0463L0.910156 34.3054L6.64449 40.077L32.0338 14.5228V32.2197H40.1409V0.846191H8.97382Z", fill: "black" }));
const ForwardRef = forwardRef(SvgVector);
export default ForwardRef;
